import i18n from '@/locales'
import { isMobile } from '.';

export enum BrowserEnv {
    WeChat = 'wechat',
    WeChatPc = 'wechat_pc',
    QQ = 'qq',
    Weibo = 'weibo',
    UC = 'uc',
    Other = 'other',
}

export function getBrowserEnv(): BrowserEnv {
    const ua = navigator.userAgent.toLowerCase();


    if (/micromessenger/.test(ua) && isMobile()) {
        return BrowserEnv.WeChat;
    }
    if (/micromessenger/.test(ua) && !isMobile()) {
        return BrowserEnv.WeChatPc;
    }
    if (/weibo/.test(ua) && isMobile()) {
        return BrowserEnv.Weibo;
    }

    // QQ 浏览器排除微信（微信 UA 里也可能包含 QQ）
    if (/qq\//.test(ua) && !/micromessenger/.test(ua) && isMobile()) {
        return BrowserEnv.QQ;
    }

    if (/ucbrowser|ucweb/.test(ua) && isMobile()) {
        return BrowserEnv.UC;
    }

    return BrowserEnv.Other;
}

export function isWechatMobile(): boolean {
    return getBrowserEnv() === BrowserEnv.WeChat && isMobile();
}

const MASK_ID = 'browser-env-mask'
const STYLE_ID = 'browser-env-mask-style'

function getTipMessage(env: BrowserEnv): string {
    const t = i18n.global.t as (k: string) => string
    switch (env) {
        case BrowserEnv.WeChat:
            return t('browserTip.wechat')
        case BrowserEnv.WeChatPc:
            return t('browserTip.wechat_pc')
        case BrowserEnv.QQ:
            return t('browserTip.qq')
        case BrowserEnv.Weibo:
            return t('browserTip.weibo')
        case BrowserEnv.UC:
            return t('browserTip.uc')
        default:
            return t('browserTip.default')
    }
}

function injectMaskStyle(): void {
    if (document.getElementById(STYLE_ID)) return
    const style = document.createElement('style')
    style.id = STYLE_ID
    style.textContent = `
#${MASK_ID} {
  position: fixed;
  inset: 0;
  z-index: 99999;
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}
.browser-env-arrow {
  position: absolute;
  top: 16px;
  right: 24px;
  width: 56px;
  height: 56px;
  color: #fff;
  animation: browser-env-bounce 1.2s ease-in-out infinite;
}
.browser-env-content {
  text-align: center;
  color: #fff;
  padding: 0 32px;
  max-width: 420px;
}
.browser-env-text {
  font-size: 17px;
  line-height: 1.7;
  margin: 0 0 24px;
  font-weight: 500;
}
.browser-env-close {
  font-size: 13px;
  opacity: 0.6;
  margin: 0;
}
@keyframes browser-env-bounce {
  0%, 100% { transform: translate(0, 0) rotate(0deg); }
  50% { transform: translate(-6px, 6px) rotate(-10deg); }
}
`
    document.head.appendChild(style)
}

function showBrowserMask(env: BrowserEnv, toast?: string): void {
    // 已存在则不再重复插入
    if (document.getElementById(MASK_ID)) return

    injectMaskStyle()

    const t = i18n.global.t as (k: string) => string

    const mask = document.createElement('div')
    mask.id = MASK_ID

    // 指向右上角的箭头
    const arrow = document.createElement('div')
    arrow.className = 'browser-env-arrow'
    arrow.innerHTML = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
      <line x1="7" y1="17" x2="17" y2="7"></line>
      <polyline points="7 7 17 7 17 17"></polyline>
    </svg>`

    const content = document.createElement('div')
    content.className = 'browser-env-content'
    content.innerHTML = `
      <p class="browser-env-text">${getTipMessage(env)}${toast || t('browserTip.next')}</p>
      <p class="browser-env-close">${t('browserTip.close')}</p>
    `

    mask.appendChild(arrow)
    mask.appendChild(content)

    mask.addEventListener('click', () => {
        mask.remove()
    })

    document.body.appendChild(mask)
}

export function checkInnerBrowser(toast?: string): boolean {
    const env = getBrowserEnv()

    if (env !== BrowserEnv.Other) {
        showBrowserMask(env, toast)
        return true
    }

    return false
}
